<template>

     <v-container fluid class="container-of-a-page-that-is-in-an-iframe">

        <v-layout>
            <v-flex v-if="errorMessage" xs12>
                <v-alert 
                    :value="true" 
                    outline 
                    type="error">
                    <span>{{ errorMessage }}</span>
                </v-alert>
            </v-flex>
            <v-flex v-else xs12>
                <PlantConfigurationTeamsTable
                    :data="teams"
                    @edit="openEdit"
                    :loading="loading"
                >
                </PlantConfigurationTeamsTable>
            </v-flex>
        </v-layout>

        <PlantConfigurationTeamsAddEdit
            :show="showAddEditDialog"
            :originalItem="editedItem"
            @close="onAddEditClose"
        >
        </PlantConfigurationTeamsAddEdit>

    </v-container>
</template>

<script>
import ConfigurationAPI from "@/api/plantConfigurationApi";
import BaseAPI from "@/api/baseApi";
import * as Constants from "@/helpers/constants";

import PlantConfigurationTeamsAddEdit from "@/components/plants/configuration/PlantConfigurationTeamsAddEdit.vue";
import PlantConfigurationTeamsTable   from "@/components/plants/configuration/PlantConfigurationTeamsTable.vue";

export default {
    props: {
        plantID: {
            required: true,
            value: Number
        }
    },
    data: function() {
        return {
            loading: false,
            errorMessage: null,

            teams: [],
            
            showAddEditDialog: false,
            editedItem: null
        }
    },
    computed: {
    },
    methods: {
        async onAddEditClose(saved) {
            this.showAddEditDialog = false;
            this.editedItem = null;

            if (saved) {
                await this.loadData();
            }
        },
        openEdit(item) {
            // when adding a new item, we need to specify the plant ID or it will come through as null
            this.editedItem = item || {
                PlantID: this.plantID,
                WorkTypeID: Constants.WORK_TYPES.PICKING.WorkTypeID
            };
            this.showAddEditDialog = true;
        },
        async loadData() {
            try {
                this.loading = true;
                this.errorMessage = null;

                this.teams = await ConfigurationAPI.getTeams(this.plantID);
            }
            catch (err) {
                this.errorMessage = await BaseAPI.parseHttpRequestError(err);

                throw err;
            }
            finally {
                this.loading = false;
            }
        }
    },
    async created() {
        await this.loadData();
    },
    components: {
        PlantConfigurationTeamsAddEdit,
        PlantConfigurationTeamsTable
    }
}
</script>

<style>
#app .container-of-a-page-that-is-in-an-iframe {
    padding: 0px;
}
</style>
